// extracted by mini-css-extract-plugin
module.exports = {"container":"add-to-basket-success_container__MZG7t","tick":"add-to-basket-success_tick__d8jM4","link":"add-to-basket-success_link__OQrHh"};